import React, { useState, useContext, useEffect } from 'react'
import { NavLink, useHistory, Link } from 'react-router-dom'
import { LOGO, SITE_NAME } from '@/utils'
// import { Link } from 'react-router-dom'
import excavator from '../../../../assets/images/Excavator-icon1.png'
import truck from '../../../../assets/images/backhoe_1.png'
import backhoe from '../../../../assets/images/backhoe_1.png'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import SecondaryButton from '@/product/components/atoms/SecondaryButton'
import {
    Badge,
    Button,
    Divider,
    ListItem,
    Menu,
    MenuItem,
    SwipeableDrawer,
} from '@material-ui/core'
import { Popover } from '@material-ui/core'
import AuthContext from '@/product/context/auth/authContext'
import CommonContext from '@/product/context/common/commonContext'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import AlertContext from '@/product/context/alert/alertContext'
import Login from '@/views/Login/login'
import { handleRedirectInternal, mapData, useCustomMediaQuery } from '@/product/common/components'
import './Header.css'
import usericon from '@/assets/images/usericn.svg'
import CustomDialog from '@/product/components/organisms/Dialog'
import SignContext from '@/custom/context/signContext'
import BidHistory from '@/custom/components/organisms/BidHistory'
import CommonFront from '@/custom/context/frontCommon/settingContext'
import Loaders from '../Loaders'
import HoverDropdown from '../../atoms/HoverDropdown'
import Dialog from '@material-ui/core/Dialog'
import { tr } from 'date-fns/locale'
import { Mail, Message, Phone, WhatsApp } from '@material-ui/icons'
import CustomDrawer from '../CustomDrawer'
import { SpinnerLoader } from '../Loaders/SpinnerLoader'
import CommonContexts from '@/custom/context/common/commonContext'
let randomVariable = Math.random()
const Header = (props) => {
    const iOS = process.browser && /iPad|iPhone|iPod/.test(navigator.userAgent)

    const commonContexts = useContext(CommonContexts)

    const {
        allNotifications,
        configFeatures,
        alldata_all_dropdown,
        allLocations,
        pinCodeValidation,
        pinCodeData,
        clearData,
    } = commonContexts
    const authContext = useContext(AuthContext)
    const {
        loginPopup,
        handleLoginPopup,
        kycPopup,
        handleKycPopup,
        handleBusign,
        setLoginPopup,
        buSign,
        handleRequestCallbackModal,
        requestCallbackModal,
    } = useContext(SignContext)

    const alertContext = useContext(AlertContext)
    const { setAlert } = alertContext
    const commonContext = useContext(CommonContext)
    const [anchormenu, setanchormenu] = useState(null)
    const [anchorcart, setanchorcart] = useState(null)
    const [toggleDisconnectDialog, setToggleDisconnectDialog] = useState(false)
    const history = useHistory()
    const menuItems = [
        { label: 'Home', path: '/' },
        { label: 'Auction', path: '/auctionsList' },
    ]

    const {
        user,

        loadPendingCount,
        isAuthenticated,
        isAdmin,
        cartCount,
        logout,
        switchUser,
        loadUser,
        login,
        responseStatus: responseStatusAuth,
        clearResponse: clearResponseAuth,
    } = authContext
    const commonFront = useContext(CommonFront)
    const {
        responseStatus: responseStatusUser,
        generateInitialBU,
        searchTableActionCBR,
        clearResponse: clearResponseCard,
    } = commonFront
    useEffect(() => {
        if (isAuthenticated) {
            setLoginPopup(false)
        }
    }, [isAuthenticated])
    const [state, setState] = useState({
        right: false,
        top: false,
    })

    const callbackFormFields = [
        {
            label: 'First Name',
            placeholder: 'First Name',
            type: 'text',
            upperLabel: true,
            class: 'col-md-6 col-12 changeInputHeight',
            name: 'first_name',
        },
        {
            label: 'Last Name',
            placeholder: 'Last Name',
            upperLabel: true,
            type: 'text',
            class: 'col-md-6 col-12 changeInputHeight',
            name: 'last_name',
        },
        // {
        //     label: 'Mobile',
        //     placeholder: 'Mobile Number',
        //     type: 'phone',
        //     upperLabel: true,
        //     class: 'col-md-6 col-12 changeInputHeight',
        //     name: 'contact_number',
        //     required: true,
        // },
        {
            label: 'Mobile Number *',
            name: 'contact_number',
            upperLabel: true,
            type: '',
            placeholder: 'Mobile Number',
            class: 'col-md-6 col-12 changeInputHeight',
            required: true,
        },
        {
            label: 'Email Address',
            placeholder: 'Email Address',
            upperLabel: true,
            type: 'text',
            class: 'col-md-6 col-12 changeInputHeight',
            name: 'email_address',
        },
        {
            label: 'Address',
            upperLabel: true,
            placeholder: 'Address',
            type: 'text',
            class: 'col-md-6 col-12 changeInputHeight',
            name: 'address',
        },
        {
            label: 'Pin Code',
            placeholder: 'Pin Code',
            upperLabel: true,
            type: 'text',
            class: 'col-md-6 col-12 changeInputHeight',
            name: 'pin_code_id',
        },
        {
            label: 'City',
            placeholder: 'City',
            type: 'text',
            upperLabel: true,
            class: 'col-md-6 col-12 changeInputHeight',
            name: 'city',
        },
        {
            label: 'State',
            placeholder: 'State',
            type: 'text',
            class: 'col-md-6 col-12 changeInputHeight',
            upperLabel: true,
            name: 'state',
        },
        {
            label: 'Description',
            placeholder: 'Description',
            type: 'textarea',
            upperLabel: true,
            class: 'col-12 changeInputHeight',
            name: 'comment',
        },
    ]

    const formik = useFormik({
        initialValues: {
            id: 0,
            first_name: '',
            last_name: '',
            contact_number: '',
            email_address: '',
            address: '',
            pin_code_id: '',
            city: '',
            state: '',
            comment: '',
            status: 1,
            request_from: 'Header',
            page: window.location.href,
        },
        validationSchema: Yup.object({
            first_name: Yup.string()
                .matches(/^[a-zA-Z ."'\-]*$/g, 'No Special Characters and Numbers Allowed')
                .min(2, 'Mininum 2 characters')
                .max(15, 'Maximum 15 characters')
                .required('Required!'),
            last_name: Yup.string()
                .matches(/^[a-zA-Z ."'\-]*$/g, 'No Special Characters and Numbers Allowed')
                .min(2, 'Mininum 2 characters')
                .max(15, 'Maximum 15 characters')
                .required('Required!'),
            contact_number: Yup.string()
                .trim()
                .matches(/^[0-9- +()]*$/g, 'Only numbers are allowed')
                .max(16, 'Maximum 10 Number')
                .min(10, 'Phone No. must be of 10 digits')
                .required('Required!'),
            email_address: Yup.string()
                .email('Invalid email address')
                .required('Email is required'),
            address: Yup.string(),
            pin_code_id: Yup.string()
                .trim()
                .matches(/^[0-9]*$/g, 'Positive Numbers only')
                .max(6, 'Maximum 6 characters')
                .required('Required'),
            city: Yup.string(),
            state: Yup.string(),
            comment: Yup.string(),
        }),
        onSubmit: (values) => {
            loaderSet(true)
            searchTableActionCBR(values)
            handleRequestCallbackModal({
                project_id: 0,
                status: false,
            })
        },
    })

    useEffect(() => {
        if (user) {
            let phone = user?.phone
            let cleaned = phone
                ?.replace(/^\+91[\s-]?/, '') // Remove leading "+91" with optional space or hyphen
                ?.replace(/\D/g, '') // Remove all non-digit characters

            formik.setFieldValue('first_name', user.first_name)
            formik.setFieldValue('last_name', user.last_name)
            formik.setFieldValue('contact_number', cleaned ? cleaned : '')
            formik.setFieldValue('email_address', user.email)
            formik.setFieldValue(
                'address',
                `${user?.address1 ? user.address1 : ''} ${user?.address1 ? ',' : ''} ${
                    user?.address2 ? user.address2 : ''
                }`,
            )
            formik.setFieldValue('city', user?.city ? user.city : '')
            formik.setFieldValue('state', user?.state ? user.state : '')
            formik.setFieldValue('pin_code_id', user.zip ? user.zip : '')
            if (window.location.href) {
                formik.setFieldValue('page', window.location.href)
            }
        }
    }, [user, handleRequestCallbackModal])

    useEffect(() => {
        if (formik?.values?.pin_code_id?.length === 6) {
            pinCodeValidation({ pin: formik?.values?.pin_code_id })
        }
    }, [formik?.values?.pin_code_id])

    useEffect(() => {
        if (pinCodeData) {
            if (pinCodeData.record && Object.keys(pinCodeData.record).length) {
                let u = pinCodeData.record
                formik.setFieldValue('country', u.country_name)
                formik.setFieldValue('state', u.state_name)

                formik.setFieldValue('city', u.city_name)

                clearData()
            } else {
                setAlert('Invalid Pincode!', 'error')
                clearData()
            }
        }
    }, [pinCodeData])

    const { searchValue, setSearchValue, isLoading, loaderSet } = commonContext

    const [searchText, setSearchText] = useState('')

    const [search, setSearch] = useState({})

    const onLogOut = () => {
        logout()
        setAlert('Logged out successfully', 'success')
        handleRedirectInternal(history, '')
        setanchormenu(null)
        setanchorcart(null)
        setSearchText('')
    }

    const toggleDrawer = (anchor, open) => (event) => {
        setState({ ...state, [anchor]: open })
    }

    const handleCart = (event) => {
        setanchorcart(event.currentTarget)
    }
    const handleMenu = (event) => {
        setanchormenu(event.currentTarget)
    }

    const handleClose = (history, path) => {
        setanchormenu(null)
        setanchorcart(null)
        if (history && path && path !== 'backdropClick') {
            console.log('history', history, path)
            handleRedirectInternal(history, path)
        }
    }

    const getSearchBarObjet = (value) => {
        return {
            limit: 12,
            page: 1,
            orderby: 'p.id, desc',
            order: '',
            filters: {
                searchbar: {
                    value: value,
                    type: 'like',
                    field: 'p.title,p.desc_proc',
                },
            },
        }
    }
    useEffect(() => {
        if (responseStatusUser) {
            if (responseStatusUser.from == randomVariable) {
                if (responseStatusUser.status === 'success') {
                    handleRedirectInternal(history, 'bidderSign')
                }
                handleBusign()
                setAlert(responseStatusUser.message, responseStatusUser.status || 'error')
            } else if (responseStatusUser.from == 'searchTableActionCBR') {
                if (responseStatusUser.status === 'success') {
                    // handleRequestCallbackModal({
                    //     project_id: 0,
                    //     status: true,
                    // })
                    formik.resetForm()
                    formik.handleReset()
                }
                setAlert(responseStatusUser.message, responseStatusUser.status || 'error')
            }

            loaderSet(false)
            clearResponseCard()
        }
    }, [responseStatusUser])
    const handleSearchTextChange = (e) => {
        setSearchText(e.target.value)
    }

    const handleSearchButtonClick = () => {
        setSearchValue(getSearchBarObjet(searchText))
        setState({ ...state, top: false })
        if (location.pathname != '/search') {
            handleRedirectInternal(history, 'search')
        }
    }

    const handleSearchKeyDown = (e) => {
        if (e.key === 'Enter') {
            setSearchValue(getSearchBarObjet(searchText))
            if (location.pathname != '/search') {
                handleRedirectInternal(history, 'search')
            }
        }
    }

    useEffect(() => {
        if (searchValue && searchValue.filters && searchValue.filters.searchbar) {
            setSearchText(searchValue.filters.searchbar.value)
        }
    }, [searchValue])
    // }, [headerToken, testMode])
    const equipmentItems = [
        {
            label: 'Buy New Equipment',
            image: backhoe,
            onClick: () => handleClose(history, 'equipment/buy_new_equipment'),
        },
        {
            label: 'Buy Used Equipment',
            image: excavator,
            onClick: () => handleClose(history, 'equipment/buy_used_equipment'),
        },
        {
            label: 'Sell Used Equipment',
            image: truck,
            onClick: () => handleClose(history, 'equipment/sell'),
        },
    ]

    return (
        <>
            {useCustomMediaQuery('(min-width: 1024px)') ? (
                <>
                    {/* DESKTOP NAVIGATION */}
                    {isLoading ? <SpinnerLoader /> : null}
                    <header className="mainHeader noPrint">
                        <div
                            className={`${
                                window.location.pathname == '/search'
                                    ? 'container-fluid'
                                    : 'customContainer'
                            } d-flex justify-content-between align-items-center h-100 headerContainer`}
                        >
                            <div className="headLt d-flex justify-content-start align-items-center">
                                <div className="ASlogo">
                                    <Link to="/">
                                        <img src={LOGO} alt={SITE_NAME} width="130" height="25" />
                                    </Link>
                                </div>
                            </div>
                            <div className="headRt middleT">
                                <ul className="d-flex justify-content-start align-items-center">
                                    <li>
                                        <Link
                                            to="/"
                                            style={{
                                                fontSize: '14px',
                                                fontWeight: '500',
                                                color: location.pathname == '/' ? 'red' : 'black',
                                            }}
                                        >
                                            Home
                                        </Link>
                                    </li>

                                    {/* <li>
                                        <HoverDropdown title="Equipment" items={equipmentItems} />
                                    </li> */}
                                    <li
                                        onClick={() =>
                                            handleRedirectInternal(history, 'auctionsList')
                                        }
                                        style={{
                                            color:
                                                location.pathname == '/auctionsList'
                                                    ? 'red'
                                                    : 'black',
                                        }}
                                    >
                                        Auctions
                                    </li>
                                    {/* <li
                                        onClick={() =>
                                            handleRedirectInternal(history, 'valuations/services')
                                        }
                                    >
                                        Valuation
                                    </li> */}
                                    {/* <li className="portal">Portal Sale</li>
                                    <li>
                                        {' '}
                                        <Button
                                            id="header_user_detail"
                                            aria-controls="simple-menu"
                                            aria-haspopup="true"
                                            className="loginRegBtn"
                                            onClick={() =>
                                                handleRedirectInternal(history, 'brand_store')
                                            }
                                        >
                                            Brand Store
                                        </Button>
                                    </li> */}
                                </ul>
                            </div>
                            <div className="menuRtOtr">
                                <div
                                    className="headRt ml-auto deskNav d-flex justify-content-end align-items-center"
                                    style={{}}
                                >
                                    <ul className="d-flex justify-content-start align-items-center">
                                        <li>
                                            <Button
                                                id="header_user_detail"
                                                aria-controls="simple-menu"
                                                aria-haspopup="true"
                                                onClick={() => {
                                                    handleRequestCallbackModal({
                                                        project_id: 0,
                                                        status: true,
                                                    })
                                                    // loadUser()
                                                }}
                                                className="callBackBtn"
                                            >
                                                <span className="material-icons">phone</span>
                                                Request a Callback
                                            </Button>
                                        </li>

                                        {isAuthenticated ? (
                                            <>
                                                {user ? (
                                                    <>
                                                        <li></li>
                                                        <li>
                                                            <img src={usericon} />
                                                            <Button
                                                                id="header_user_detail"
                                                                aria-controls="simple-menu"
                                                                aria-haspopup="true"
                                                                endIcon={
                                                                    <span className="material-icons">
                                                                        arrow_drop_down
                                                                    </span>
                                                                }
                                                                onClick={handleMenu}
                                                            >
                                                                {`Hi, ${user.first_name} `}
                                                                {/* {user.last_name
                                                                    ? `${user.last_name}`
                                                                    : ''} */}
                                                            </Button>

                                                            <Popover
                                                                id={'simple-menu'}
                                                                open={Boolean(anchormenu)}
                                                                anchorEl={anchormenu}
                                                                onClose={handleClose}
                                                                anchorOrigin={{
                                                                    vertical: 'bottom',
                                                                    horizontal: 'right',
                                                                }}
                                                                transformOrigin={{
                                                                    vertical: 'top',
                                                                    horizontal: 'right',
                                                                }}
                                                            >
                                                                <ul
                                                                    className={`headerDropMenu afterLogin ${
                                                                        document.body.dir ===
                                                                            'rtl' && 'rtl'
                                                                    }`}
                                                                >
                                                                    <ListItem
                                                                        button
                                                                        onClick={() =>
                                                                            handleClose(
                                                                                history,
                                                                                'account/dashboard',
                                                                            )
                                                                        }
                                                                        id="header_mybids"
                                                                    >
                                                                        {/* <span className="material-icons">
                                                                            gavel
                                                                        </span> */}
                                                                        {'Dashboard'}
                                                                    </ListItem>
                                                                    <ListItem
                                                                        button
                                                                        id="header_logout"
                                                                        onClick={() => onLogOut()}
                                                                    >
                                                                        {/* <span className="material-icons">
                                                                            power_settings_new
                                                                        </span> */}
                                                                        {'Logout'}
                                                                    </ListItem>
                                                                </ul>
                                                            </Popover>
                                                        </li>
                                                    </>
                                                ) : null}
                                            </>
                                        ) : (
                                            <li>
                                                <Button
                                                    id="header_user_detail"
                                                    aria-controls="simple-menu"
                                                    aria-haspopup="true"
                                                    onClick={handleMenu}
                                                    className="loginRegBtn"
                                                >
                                                    Log In/Sign Up
                                                </Button>

                                                <Popover
                                                    id={'simple-menu'}
                                                    open={Boolean(anchormenu)}
                                                    anchorEl={anchormenu}
                                                    onClose={handleClose}
                                                    anchorOrigin={{
                                                        vertical: 'bottom',
                                                        horizontal: 'right',
                                                    }}
                                                    transformOrigin={{
                                                        vertical: 'top',
                                                        horizontal: 'right',
                                                    }}
                                                >
                                                    <ul
                                                        className={`headerDropMenu ${
                                                            document.body.dir === 'rtl' && 'rtl'
                                                        }`}
                                                    >
                                                        <ListItem
                                                            button
                                                            id="header_mybids"
                                                            className="col-6"
                                                        >
                                                            <div className="mb-1">
                                                                <h4>Welcome Back</h4>
                                                                <span>
                                                                    If you already have an account,
                                                                    please sign in below.
                                                                </span>
                                                            </div>

                                                            <PrimaryButton
                                                                id="bidding_submit"
                                                                // onClick={formikPayment.handleSubmit}
                                                                type="button"
                                                                label={'Customer/Partner'}
                                                                onClick={() =>
                                                                    handleClose(history, 'login')
                                                                }
                                                            />
                                                        </ListItem>
                                                        <ListItem className="headerPartition">
                                                            <hr />
                                                            <span>OR</span>
                                                            <hr />
                                                        </ListItem>
                                                        <ListItem
                                                            id="header_mybids"
                                                            // className="col-6"
                                                        >
                                                            <span className="notMemberSpan">
                                                                Not a member yet? Sign up as
                                                            </span>
                                                            <SecondaryButton
                                                                label="Customer"
                                                                btnSize="small"
                                                                className="loginSec"
                                                                onClick={() =>
                                                                    handleClose(
                                                                        history,
                                                                        'registration/customer',
                                                                    )
                                                                }
                                                            />
                                                            {/* <span style={{ fontSize: '14px' }}>
                                                                OR
                                                            </span>
                                                            <SecondaryButton
                                                                label="Partner"
                                                                btnSize="small"
                                                                className="loginSec"
                                                                onClick={() =>
                                                                    handleClose(
                                                                        history,
                                                                        'registration/dealer',
                                                                    )
                                                                }
                                                            /> */}
                                                        </ListItem>
                                                    </ul>
                                                </Popover>
                                            </li>
                                        )}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </header>
                </>
            ) : (
                <>
                    {/* MOBILE / TAB NAVIGATION */}
                    <header className="mainHeader customContainer d-flex justify-content-between align-items-center">
                        <div className="mobileLeftMenu d-flex justify-content-start">
                            <CustomDrawer
                                anchor="left"
                                buttonLabel={
                                    <button className="drawerMenu">
                                        <span className="material-icons">menu</span>
                                    </button>
                                }
                                items={menuItems}
                            />
                            <Link to="/" className="navloGo">
                                <img src={LOGO} alt={SITE_NAME} width="130" height="25" />
                            </Link>
                        </div>
                        <div className="mobileRightNavMenu">
                            <img
                                className=""
                                onClick={() => {
                                    handleRequestCallbackModal({
                                        project_id: 0,
                                        status: true,
                                    })
                                }}
                                src={`/assets/svg/customer-service.svg`}
                                alt="CustomerServer"
                                width={100}
                                height={100}
                            />
                            {/* <img
                                src={`/assets/svg/account.svg`}
                                alt="CustomerServer"
                                width={100}
                                height={100}
                            /> */}
                            <div>
                                <img
                                    src={`/assets/svg/account.svg`}
                                    alt="Account"
                                    width={30}
                                    height={30}
                                    onClick={handleMenu}
                                    style={{ cursor: 'pointer' }}
                                />

                                {/* Popover Dropdown */}
                                <Popover
                                    id={'simple-menu4'}
                                    open={Boolean(anchormenu)}
                                    anchorEl={anchormenu}
                                    onClose={handleClose}
                                    anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'right',
                                    }}
                                    transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'right',
                                    }}
                                >
                                    {!isAuthenticated && user ? (
                                        <ul
                                            className={`headerDropMenu ${
                                                document.body.dir === 'rtl' ? 'rtl' : ''
                                            }`}
                                            style={{ width: '300px', padding: '16px' }}
                                        >
                                            {/* Sign In Block */}
                                            <ListItem button id="header_mybids" className="col-6">
                                                <div className="mb-2">
                                                    <h4 style={{ marginBottom: 4 }}>
                                                        Welcome Back
                                                    </h4>
                                                    <span style={{ fontSize: 12 }}>
                                                        If you already have an account, please sign
                                                        in below.
                                                    </span>
                                                </div>

                                                <PrimaryButton
                                                    id="bidding_submit"
                                                    type="button"
                                                    label={'Customer / Partner'}
                                                    onClick={() => handleClose(history, 'login')}
                                                />
                                            </ListItem>

                                            {/* Divider */}
                                            <ListItem
                                                className="headerPartition"
                                                style={{ justifyContent: 'center' }}
                                            >
                                                <hr style={{ width: '30%' }} />
                                                <span style={{ padding: '0 8px' }}>OR</span>
                                                <hr style={{ width: '30%' }} />
                                            </ListItem>

                                            {/* Sign Up Block */}
                                            <ListItem id="header_signup" className="col-6">
                                                <span
                                                    className="notMemberSpan"
                                                    style={{ fontSize: 13 }}
                                                >
                                                    Not a member yet? Sign up as
                                                </span>

                                                <SecondaryButton
                                                    label="Customer"
                                                    btnSize="small"
                                                    className="loginSec"
                                                    onClick={() =>
                                                        handleClose(
                                                            history,
                                                            'registration/customer',
                                                        )
                                                    }
                                                />

                                                {/* Uncomment below if Partner registration is needed */}
                                                {/* <span style={{ fontSize: '14px' }}>OR</span>
                        <SecondaryButton
                            label="Partner"
                            btnSize="small"
                            className="loginSec"
                            onClick={() =>
                                handleClose(history, 'registration/dealer')
                            }
                        /> */}
                                            </ListItem>
                                        </ul>
                                    ) : (
                                        <ul
                                            className={`headerDropMenu afterLogin ${
                                                document.body.dir === 'rtl' && 'rtl'
                                            }`}
                                        >
                                            <ListItem
                                                button
                                                onClick={() =>
                                                    handleClose(history, 'account/dashboard')
                                                }
                                                id="header_mybids"
                                            >
                                                {/* <span className="material-icons">
                                                                            gavel
                                                                        </span> */}
                                                {'Dashboard'}
                                            </ListItem>
                                            <ListItem
                                                button
                                                id="header_logout"
                                                onClick={() => onLogOut()}
                                            >
                                                {/* <span className="material-icons">
                                                                            power_settings_new
                                                                        </span> */}
                                                {'Logout'}
                                            </ListItem>
                                        </ul>
                                    )}
                                </Popover>
                            </div>
                        </div>
                    </header>
                </>
            )}
            <BidHistory />{' '}
            <CustomDialog
                className="fileUploadModal"
                title={'KYC Details Incomplete'}
                open={kycPopup}
                function={handleKycPopup}
                maxWidth="md"
                disableBackdropClick={false}
            >
                <h4 className="fpTitle">
                    You need to complete your KYC profile with iQuippo to make payments. Click Yes
                    if you want to proceed or No if you want to do this later.
                </h4>
                <div className="actionWrapper d-flex justify-content-end py-3">
                    <PrimaryButton
                        label="Yes"
                        btnSize="small"
                        onClick={() => {
                            handleKycPopup()
                            handleRedirectInternal(history, 'account/profile')
                        }}
                    />
                    <SecondaryButton
                        className="ml-3"
                        label="No"
                        btnSize="small"
                        onClick={handleKycPopup}
                    />
                </div>
            </CustomDialog>
            {!isLoading ? (
                <CustomDialog
                    className="fileUploadModal"
                    title={'Confirm'}
                    open={buSign?.status}
                    function={handleBusign}
                    maxWidth="md"
                    disableBackdropClick={false}
                >
                    <h4 className="fpTitle">
                        Please sign a bidder undertaking form with iQuippo to proceed for the
                        auction registration. This is a one time activity which you need to perform
                        and upon successful completion, you can participate in all iQuippo auctions.
                    </h4>
                    <div className="actionWrapper d-flex justify-content-end py-3">
                        <PrimaryButton
                            label="Confirm"
                            btnSize="small"
                            onClick={() => {
                                randomVariable = Math.random()
                                generateInitialBU({ ...buSign }, randomVariable)
                                loaderSet(true)
                            }}
                        />
                        <SecondaryButton
                            className="ml-3"
                            label="Cancel"
                            btnSize="small"
                            onClick={handleBusign}
                        />
                    </div>
                </CustomDialog>
            ) : null}
            <Dialog
                open={loginPopup}
                function={handleLoginPopup}
                onClose={handleLoginPopup}
                className="lgnWrpr loginPopup"
            >
                <div className="lgnCntnr">
                    {/* <IconButton className="popClrBtn" onClick={handleLoginPopup}>
                        <span className="material-icons">clear</span>
                    </IconButton> */}
                    <Login />
                </div>
            </Dialog>
            {!isLoading ? (
                <CustomDialog
                    title={requestCallbackModal.project_id ? 'Price On Request' : ''}
                    open={requestCallbackModal.status}
                    function={() => {
                        handleRequestCallbackModal({
                            project_id: 0,
                            status: false,
                        })
                        formik.resetForm()
                    }}
                    handleClose={() => {
                        handleRequestCallbackModal({
                            project_id: 0,
                            status: false,
                        })
                        formik.resetForm()
                    }}
                    className="requestCallbackModal customDialogBg"
                    maxWidth="md"
                >
                    <div className="row formContainer p-0">
                        {mapData({ data: callbackFormFields, formik })}
                    </div>

                    <div className="actionWrapper buttonWrapper mr-3">
                        <Button
                            type="button"
                            className="custPrimaryButton m-0"
                            onClick={() => {
                                handleRequestCallbackModal()
                                formik.resetForm()
                            }}
                        >
                            Cancel
                        </Button>
                        <Button
                            type="submit"
                            onClick={formik.handleSubmit}
                            className="custSecondaryButton"
                        >
                            Submit
                        </Button>
                    </div>

                    <hr className="mb-0" />
                    <div className="reach-us-section formContainer">
                        <h6 className="fw-bold ">Reach Us</h6>
                        <p className="text-muteds small mb-3">
                            You can contact our customer support team using the below options:
                        </p>
                        <div
                            className="d-flex justify-content-between gap-3"
                            style={{ flexWrap: 'wrap', gap: '15px' }}
                        >
                            <div className="d-flex align-items-center">
                                <div className="reach-us-icon">
                                    <Phone className=" me-2" size={18} />
                                </div>
                                <div className="d-flex flex-column">
                                    <span className="text-muted small pl-2">MOBILE</span>
                                    <span className="text-muted small pl-2">+91 - 8860041888</span>
                                </div>
                            </div>
                            <div className="d-flex align-items-center">
                                <div className="reach-us-icon">
                                    <Mail className=" me-2" size={18} />
                                </div>
                                <div className="d-flex flex-column">
                                    <span className="text-muted small pl-2">EMAIL</span>
                                    <span className="text-muted small pl-2">
                                        customercare@iquippo.com
                                    </span>
                                </div>
                            </div>
                            <div className="d-flex align-items-center">
                                <div className="reach-us-icon">
                                    <WhatsApp className=" me-2" size={18} />
                                </div>
                                <div className="d-flex flex-column">
                                    <span className="text-muted small pl-2">WHATSAPP</span>
                                    <span className="text-muted small pl-2">+91 - 8860041888</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </CustomDialog>
            ) : null}
        </>
    )
}
export default Header
